"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appSagas = void 0;

var _effects = require("redux-saga/effects");

var _saga = require("./updateFlow/saga");

var _actions = require("../auth/actions");

var _selectors = require("../locale/selectors");

var _actions2 = require("../apiFlow/messages/actions");

var _actions3 = require("../apiFlow/version/actions");

var _selectors2 = require("../auth/selectors");

var _actions4 = require("../apiFlow/customTableViews/loadAll/actions");

var _reduxPersist = require("redux-persist");

var _Utils = _interopRequireDefault(require("../../utils/Utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(appInitialWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(appInitialWatcher);

function appInitialWorker() {
  var locale, isAuthorized;
  return regeneratorRuntime.wrap(function appInitialWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _actions.tokenTimeoutCheckerSaga)());

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _actions3.saga)());

        case 4:
          _context.next = 6;
          return (0, _effects.select)(_selectors.getLocale);

        case 6:
          locale = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _actions2.saga)(locale));

        case 9:
          _Utils["default"].setMomentLocale(locale); // Load custom table app.views


          _context.next = 12;
          return (0, _effects.select)(_selectors2.getIsAuth);

        case 12:
          isAuthorized = _context.sent;

          if (!isAuthorized) {
            _context.next = 16;
            break;
          }

          _context.next = 16;
          return (0, _effects.put)((0, _actions4.saga)());

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function appInitialWatcher() {
  return regeneratorRuntime.wrap(function appInitialWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_reduxPersist.REHYDRATE, appInitialWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var appSagas = [appInitialWatcher, _saga.updateFlowWatcher];
exports.appSagas = appSagas;